module.exports = __webpack_public_path__ + "img/tcfw.94a842a4.jpg";